/* eslint-disable react-hooks/exhaustive-deps */
import { Dropdown, DropdownProps } from "primereact/dropdown";
import { Alert, Loader } from "..";
import { useEffect, useRef, useState } from "react";
import { IResponse } from "../../services/model";
import { FxTranslate } from "../../core/translate";
import { OverlayPanel } from 'primereact/overlaypanel';
import { Button, SelectButton } from "../prime";

export interface CnetDropdownProps extends DropdownProps {
  t: FxTranslate;
  title?: string;
  optionsAsync?: (activo?: boolean) => Promise<IResponse<any>>;
  optionsTransform?: (data: any[]) => any[];
  useActiveDinamicFilter?: boolean;
}
function CnetDropDown({ optionsAsync, optionsTransform, t, title, useActiveDinamicFilter, ...props } : CnetDropdownProps) {
  const op = useRef<OverlayPanel>(null);
  const [ loading, setLoading ] = useState<'none' | 'cargar' | 'cargando'>('none');
  const [ data, setData ] = useState<any[] | undefined>();
  const [ filterActivo, setFiltroActivo ] = useState<boolean | undefined>(true);

  useEffect(() => setLoading('cargar'), []);
  useEffect(() => { if (useActiveDinamicFilter) setLoading('cargar') }, [filterActivo]);

  useEffect(() => {
    if (loading !== 'cargar') return;
    if (!optionsAsync) return setLoading('none');
    setLoading('cargando');
    !!optionsAsync && optionsAsync(filterActivo).then(res => {
      if (!res.success || !res.data) Alert.reponse(res);
      setData(res.data);
    }).catch(ex => Alert.exception(t, ex))
    .finally(() => setLoading('none'))
  }, [loading]);

  
  return <Loader loading={loading === 'cargando'}>
    <div className={`form-group`} style={{ marginBottom: !!title ? undefined : 0 }}>
      {title && <label style={{ marginBottom: 0 }}>{title}</label>}
      <div className={`p-inputgroup`}>
        {props.required && 
          <span className={`p-inputgroup-addon`}>
            <i className="pi pi-exclamation-circle" />
          </span>
        }
        <Dropdown options={!!optionsTransform ? optionsTransform(data ?? []) : data} {...props} style={{ width: '100%' }} />
        {useActiveDinamicFilter && 
          <Button type="button" icon="pi pi-filter" className="p-button-secondary" onClick={(e) => op?.current?.toggle(e, undefined)} />
        }
        <OverlayPanel ref={op}>
          <SelectButton
            optionLabel="name" 
            optionValue="value" 
            multiple
            value={filterActivo === undefined ? [true,false] : [filterActivo]}
            className="p-column-filter"
            style={{ textAlign:'center', width: 'auto' }}
            options={[
              { name: 'Activo', value: true, icon: 'fas fa-check'},
              { name: 'Inactivo', value: false, icon: 'fas fa-ban'},
            ]}
            itemTemplate={o => <i className={`${o.icon}`} style={{ fontSize: '1em', width: '1em'}} />}
            onChange={(e) => {
              if (typeof e.value === 'boolean') 
                setFiltroActivo(e.value)
              else if (e.value.length === 1)
                setFiltroActivo(e.value[0])
              else 
                setFiltroActivo(undefined);
            }}
          />
        </OverlayPanel>
      </div>
    </div>

      
  </Loader>
}


export default CnetDropDown;